<ng-container *ngIf="schema && show">
    <div class="main-form-field">
        <label class="label" [for]="fieldId" *ngIf="schema.label">
            {{schema.label}}
            <span class="required" *ngIf="isRequiredField()">*</span>
        </label>

        <div class="form-field"
            [class.nb-form-field-control-with-suffix]="schema.suffixIcon || schema.suffixText || schema.suffixButton">
            <!-- TODO: -->

            <div class="field">
                <ng-container #FieldContainer></ng-container>
            </div>
            <!-- suffix element -->
            <div class="nb-form-field-addon " [ngClass]="['nb-form-field-suffix-'+schema.size]"
                *ngIf="schema.suffixIcon || schema.suffixText || schema.suffixButton">
                <!-- suffix button -->
                <button-widget *ngIf="schema.suffixButton && schema.__suffixButtonWidget" [widgetForm]="widgetForm"
                    [widgetHeader]="schema.__suffixButtonWidget"></button-widget>
                <!-- TODO: -->
            </div>

        </div>
        <!-- error -->
        <div class="error" *ngIf="errorMessage">{{errorMessage}}</div>
        <!-- hint -->
        <div class="hint" *ngIf="schema.hint">{{schema.hint}}</div>
    </div>
</ng-container>